export default __webpack_public_path__ + "static/media/Rpets.b244028f.svg";